export class ParametrosCB {
  paramConciBanca: {
    idBanco: string;
    idEmpresa: string;
    claveBanco: string;
    formatoDucumento: string;
    saldoDisponibleInDetalle: boolean;
    columnaSaldoDispoible: number;
    filaSaldoDisponible: number;
    lineaInicialDatosCabecera: number;
    lineaInicialDatosDetalle: number;
    separador: string;
    //otroDelimitador: string;
  }
  listParamCampo: [{
    idBanco: string;
    idEmpresa: string;
    pisicionColumna: number;
    nombreCampo: string;
  }];

  constructor(innParametrosCB: ParametrosCB) {
    this.paramConciBanca = innParametrosCB.paramConciBanca;
    this.listParamCampo = innParametrosCB.listParamCampo;
  }
}
